import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo-part-living.svg'
import _imports_1 from '@/assets/logo-part-vivant.svg'


const _hoisted_1 = { class: "splash-page__content" }
const _hoisted_2 = { class: "logo-parts" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "VIMY", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo-parts__living",
  alt: "Living"
}, null, -1)
const _hoisted_5 = { class: "logo-parts__memorial" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "logo-parts__vivant",
  alt: "Vivant"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ENGLISH ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" FRANÇAIS ")
const _hoisted_9 = {
  key: 0,
  class: "splash-page__error"
}
const _hoisted_10 = { class: "error-message" }
const _hoisted_11 = { class: "splash-page__footer" }
const _hoisted_12 = { class: "partners container" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["splash-page", { loading: !_ctx.hasLogoAnimationPlayed, ready: _ctx.hasLogoAnimationPlayed }])
  }, [
    _createVNode(_component_MainLayout, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Loading, { ref: "loading" }, null, 512)
            ]),
            _hoisted_6
          ]),
          _withDirectives(_createVNode(_component_router_link, {
            class: "btn btn-start en",
            to: { name: 'IntroductionPage', params: { lang: 'en' } },
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLocale('en')))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 512), [
            [_vShow, !_ctx.error]
          ]),
          _withDirectives(_createVNode(_component_router_link, {
            class: "btn btn-start fr",
            to: { name: 'IntroductionPage', params: { lang: 'fr' } },
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLocale('fr')))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 512), [
            [_vShow, !_ctx.error]
          ])
        ]),
        (_ctx.error && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _withDirectives(_createElementVNode("h2", _hoisted_10, null, 512), [
                [_directive_translate, `app.generic_error_message`]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("h4", null, null, 512), [
            [_directive_translate, `splash_page.partner_interactive_msg`]
          ]),
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                (partner.url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      href: partner.url
                    }, [
                      _createElementVNode("img", {
                        src: partner.logo,
                        alt: partner.name
                      }, null, 8, _hoisted_14)
                    ], 8, _hoisted_13))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: partner.logo,
                      alt: partner.name
                    }, null, 8, _hoisted_15))
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    })
  ], 2))
}